import { IBusinessRepository } from '@/businessRepository/interfaces/businessRepository';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 *  全ての取引情報をBusinessManagerから抽出する
 */
export class GetAllBusinessUseCase {
  /**
   * businessIdsにマッチする取引を取得する
   * @param businessRepository - 取引情報の永続化の責務を負うクラス
   * @returns 取引情報
   */
  public static Execute = async (businessRepository: IBusinessRepository): Promise<INetworkResult<IBusiness[], Error>> => {
    const result = await businessRepository.allGet();
    return result;
  };
}
